import { Model, Factory } from 'miragejs'
import type { ModelDefinition } from 'miragejs/-types'
import { randUuid } from '@ngneat/falso'

import type { SchemaAttributes } from '../types.js'
import type { MockServer, MirageServer } from './server.js'
import type { PostcodeLookupResponse } from '@/models/address.js'

export type UKPostcodeLookupData = SchemaAttributes<'UKPostcodeLookup'>

export const model = Model as ModelDefinition<UKPostcodeLookupData>

export const factory = Factory.extend<UKPostcodeLookupData>({
  postcode() {
    return 'SW1A 1AA'
  },
  task_id() {
    return randUuid()
  },
})

export function routes(server: MockServer) {
  server.post(
    '/postcodes/uk_lookup',
    function (this: MirageServer, schema, request) {
      const { data } = JSON.parse(request.requestBody)
      const { postcode } = data.attributes

      const fixedData: PostcodeLookupResponse = {
        Latitude: 51.5074,
        Longitude: -0.1278,
        Addresses: [
          '1 High Street, , , , , Sample Town, ',
          '2 High Street, , , , , Sample Town, ',
          '3 High Street, , , , , Sample Town, ',
        ],
      }

      return {
        data: {
          type: 'UKPostcodeLookup',
          attributes: {
            postcode,
            data: fixedData,
          },
        },
      }
    },
  )
}
